import styled from 'styled-components';
import {dFlex, dFlexColumn, flexWrap, alignCenter, justifyCenter} from '../../../globalVariables/GlobalFlex';
import {getFontSize, getFontWeight, getSpacing, getToken} from '@tickchak/react-share/app';

export const feedbackSection = styled.div`
    ${dFlex}
    ${flexWrap}
    ${alignCenter}
    ${justifyCenter}
    gap: ${getSpacing('spaceMd')};
    padding: ${getSpacing('spaceXl')} 0 ${getSpacing('spaceXl')};
    width: 100%;
`;

export const feedbackText = styled.div`
    ${dFlexColumn}
    ${alignCenter}
    text-align: center;
    
    strong {
        font-size: ${getFontSize('body')};
        font-weight: ${getFontWeight('bold')};
        line-height: ${getToken('typography.lineHeight.body')};
        color: ${getToken('color.text.default')};
    }
    
    span {
        font-size: ${getFontSize('body')};
        font-weight: ${getFontWeight('regular')};
        line-height: ${getToken('typography.lineHeight.body')};
        color: ${getToken('color.text.default')};
    }
`;
